import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-avatar-group',
  templateUrl: './avatar-group.component.html',
  styleUrls: ['./avatar-group.component.scss']
})
export class AvatarGroupComponent implements OnInit, OnChanges {
  @Input() users = null;
  @Input() maximumNumberUsersDisplay = 0;
  @Input() group = false;

  displayUsers: any[] = [];

  constructor() { }

  ngOnInit(): void {
    this.updateDisplayUsers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['users']) {
      this.updateDisplayUsers();
    }
  }

  updateDisplayUsers(): void {
    let list = this.users;
    if (typeof list === 'string') {
      try {
        list = JSON.parse(list);
      } catch (e) {
        list = [];
      }
    }
    if (!Array.isArray(list)) {
      this.displayUsers = [];
      return;
    }
    if (list.some(u => u && u.order !== undefined && u.order !== null)) {
      this.displayUsers = [...list].sort((a, b) => (Number(a?.order) || 0) - (Number(b?.order) || 0));
    } else {
      this.displayUsers = [...list];
    }
  }

  get overflowUsers(): any[] {
    if (!this.displayUsers || this.maximumNumberUsersDisplay <= 0) return [];
    return this.displayUsers.slice(this.maximumNumberUsersDisplay);
  }

  getStatusColor(status: string): string {
    if (!status) return '';
    switch (status.toUpperCase()) {
      case 'APPROVED':
      case 'APROBADO':
        return '#22c55e'; // Verde
      case 'OBSERVED':
      case 'OBSERVADO':
        return '#eab308'; // Amarillo
      case 'PENDING':
      case 'PENDIENTE':
      case 'NOT_PENDING':
      case 'NO_PENDIENTE':
        return '#ef4444'; // Rojo
      default:
        return '#ef4444';
    }
  }

  getStatusLabel(status: string): string {
    if (!status) return '';
    switch (status.toUpperCase()) {
      case 'APPROVED':
      case 'APROBADO':
        return 'APROBADO';
      case 'OBSERVED':
      case 'OBSERVADO':
        return 'OBSERVADO';
      case 'PENDING':
      case 'PENDIENTE':
      case 'NOT_PENDING':
      case 'NO_PENDIENTE':
        return 'PENDIENTE';
      default:
        return status;
    }
  }

  getUserTooltip(user: any): string {
    if (!user) return '';
    const fullName = `${user.name || ''} ${user.lastName || ''}`.trim();
    const position = user.positionName || user.position;
    const statusLabel = user.status ? this.getStatusLabel(user.status) : '';

    const parts: string[] = [];
    if (fullName) parts.push(fullName);
    if (position) parts.push(`(${position})`);
    if (statusLabel) parts.push(`- ${statusLabel}`);
    return parts.length > 0 ? parts.join(' ') : (user.email || '');
  }
}

